import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {

  constructor() {
    //this.status = 'warning'
  }

  @Input() status: string;
  @Input() text: string;
  @Input() linkText: string;
  @Input() rounded: boolean = true;
  @Input() isCloseable: boolean = false;
  @Output() rejectClick =  new EventEmitter();
  @Output() linkClick =  new EventEmitter();
  ngOnInit(): void {
    
  }

  public get theme(): string {
    return this.status;
  }

  public get icon(): string {
    switch (this.status) {
      case 'ok':
          return 'done';
      case 'error':
        return 'warning';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      case 'advise':
        return 'notification_important';
      default:
        return '';
    }
  }

  onRejectClick() {
    this.rejectClick.emit()  
  }

  onLinkClick() {
    this.linkClick.emit()  
  }

}
